import { useSearchParams } from "react-router-dom";
import ContextFeed from "@/components/ContextFeed";

// Bare, iframe-embeddable contextual feed for sister sites.
// e.g. /embed/context?entity_type=species&entity_id=bald-eagle&limit=8&layout=carousel
export default function EmbedContext() {
  const [p] = useSearchParams();
  return (
    <div style={{ background: "transparent" }} className="p-3">
      <ContextFeed
        entityType={p.get("entity_type")}
        entityId={p.get("entity_id")}
        site={p.get("site")}
        place={p.get("place")}
        tags={p.get("tags")}
        title={p.get("title") || undefined}
        layout={p.get("layout") === "carousel" ? "carousel" : "grid"}
        limit={Number(p.get("limit")) || 12}
        showEmpty
      />
      <a href={window.location.origin} target="_blank" rel="noopener noreferrer"
        className="mt-2 block text-right text-[10px] font-semibold uppercase tracking-wide text-[#F27A54]">
        Powered by PhotoPulse.pro
      </a>
    </div>
  );
}
